import { useDispatch, useSelector } from "react-redux"
import {
  Box,
  Skeleton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material"
import { toggleShowOrderSummary } from "src/features/checkout/checkoutSlice"
import { currencyFormat } from "src/app/utils"

export default function CartMobileToggleButton() {
  const dispatch = useDispatch()
  const theme = useTheme()
  const downMd = useMediaQuery(theme.breakpoints.down("md"))
  const { cart, showOrderSummary } = useSelector((state) => state.checkout)

  if (downMd) {
    return (
      <Box
        sx={styles.toggleContainer}
        onClick={() => dispatch(toggleShowOrderSummary())}
      >
        <Box display="flex" alignItems="center">
          <Box sx={styles.cartIcon}>{cartIcon}</Box>
          <Typography color="primary" variant="body2">
            {showOrderSummary ? "Hide" : "Show"} order summary
          </Typography>
          <Box sx={styles.arrowIcon}>
            {showOrderSummary ? arrowUpIcon : arrowDownIcon}
          </Box>
        </Box>
        <Box>
          {cart.cost?.totalAmount?.amount ? (
            <Typography>
              {currencyFormat(cart.cost?.totalAmount?.amount)}
            </Typography>
          ) : (
            <Skeleton width={80} />
          )}
        </Box>
      </Box>
    )
  }

  return <></>
}

const styles = {
  toggleContainer: {
    borderBottom: "#f0f0f0 1px solid",
    borderTop: "#f0f0f0 1px solid",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    py: 3,
    px: 2,
    userSelect: "none",
  },
  cartIcon: {
    width: "18px",
    stroke: "#ab211c",
    fill: "#ab211c",
    mr: 1,
  },
  arrowIcon: {
    width: "10px",
    stroke: "#ab211c",
    fill: "none",
    ml: 1,
  },
}

const cartIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    focusable="false"
    aria-hidden="true"
  >
    <circle cx="3.5" cy="11.9" r="0.3"></circle>
    <circle cx="10.5" cy="11.9" r="0.3"></circle>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.502 11.898h-.004v.005h.004v-.005Zm7 0h-.005v.005h.005v-.005ZM1.4 2.1h.865a.7.7 0 0 1 .676.516l1.818 6.668a.7.7 0 0 0 .676.516h5.218a.7.7 0 0 0 .68-.53l1.05-4.2a.7.7 0 0 0-.68-.87H3.4"
    ></path>
  </svg>
)

const arrowDownIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    focusable="false"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m11.9 5.6-4.653 4.653a.35.35 0 0 1-.495 0L2.1 5.6"
    ></path>
  </svg>
)

const arrowUpIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    focusable="false"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m2.1 8.4 4.653-4.653a.35.35 0 0 1 .495 0L11.9 8.4"
    ></path>
  </svg>
)
